import { render, staticRenderFns } from "./xuefei.vue?vue&type=template&id=37b6dcb4&scoped=true&"
import script from "./xuefei.vue?vue&type=script&lang=js&"
export * from "./xuefei.vue?vue&type=script&lang=js&"
import style0 from "./xuefei.vue?vue&type=style&index=0&id=37b6dcb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b6dcb4",
  null
  
)

export default component.exports